import React from "react";
import styled from "styled-components";
import PretendardText from "../text/pretendardText";

const BasicBtn = (props) => {
  return (
    <StyledBasicBtn
      style={{
        ...props.style,
      }}
      onClick={props.onClick}
      isTransparent={props.isTransparent}
      isBlue={props.isBlue}
    >
      <BasicBtnText isBlue={props.isBlue}>{props.children}</BasicBtnText>
    </StyledBasicBtn>
  );
};

export default BasicBtn;

const StyledBasicBtn = styled.button.attrs((props) => {})`
  width: fit-content;
  height: fit-content;
  padding: 12px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) =>
    props.isBlue
      ? "transparent"
      : props.isTransparent
      ? "transparent"
      : "#272829"};
  border: ${(props) =>
    props.isBlue
      ? "1px solid #009bde"
      : props.isTransparent
      ? "1px solid var(--outline2, rgba(255, 255, 255, 0.6))"
      : "1px solid var(--outline1, rgba(255, 255, 255, 0.12))"};
  border-radius: 4px;
  &:hover {
    background-color: inherit;
  }
`;

const BasicBtnText = styled(PretendardText).attrs((props) => {})`
  font-weight: 600;
  font-size: 15px;
  line-height: 24.5px;
  color: ${(props) => (props.isBlue ? "#009bde" : "#aaa")};
`;
